<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Dobry Agent'" [name]="'Artukuły'"></app-breadcrumb>
<div class="post-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <mat-form-field class="post-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Nazwa" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>
    <mat-form-field class="post-list-filter">
      <mat-label>Autor</mat-label>
      <input matInput placeholder="JanKow123" name="author" [(ngModel)]="initialFilters.author">
    </mat-form-field>

    <app-datepicker
      class="post-list-filter"
      label="Data publikacji od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$publicationDate" name="gte$publicationDate"
    ></app-datepicker>

    <app-datepicker
      class="post-list-filter"
      label="Data publikacji do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$publicationDate" name="lte$publicationDate"
    ></app-datepicker>

    <mat-form-field
      appearance="standard"
      class="post-list-filter">
      <mat-label>Aktywny</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <app-dict-dobry-agent-blog-categories
      class="post-list-filter"
      label="Kategoria"
      [multiple]="true"
      [required]="false"
      [(ngModel)]="initialFilters.in$categories" name="in$categories"
    >
    </app-dict-dobry-agent-blog-categories>
    <app-dict-dobry-agent-blog-tags
      class="post-list-filter"
      label="Tagi"
      [hiddenChips]="true"
      [required]="false"
      [(ngModel)]="initialFilters.in$tags" name="in$tags"
    >
    </app-dict-dobry-agent-blog-tags>
    <mat-form-field
      appearance="standard"
      class="post-list-filter">
      <mat-label>Archiwum</mat-label>
      <mat-select [(ngModel)]="initialFilters.deleted" name="deleted">
        <mat-option [value]="null">Bez archiwum</mat-option>
        <mat-option [value]="'1'">Tylko archiwum</mat-option>
        <mat-option value="all">Wszyscy</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="post-list-filter-full">
      <mat-label>Szukaj</mat-label>

      <input
        matInput
        type="search"
        name="contains$context"
        placeholder="Nazwa artykułu, kategoria lub autor"
        [(ngModel)]="initialFilters.contains$context"
      >
    </mat-form-field>
  </form>

  <div >
    <div class="add-button">
      <a  [routerLink]="['/blog-dobry-agent/artykuly/dodaj']">
        <button  [disabled]="!(userPermissions | async).dobry_agent.write" (click)="add()"  mat-raised-button color="accent" >
          <mat-icon>add</mat-icon> <span> Dodaj artykuł</span>
        </button>
      </a>
    </div>

    <div class="post-list-buttons">

      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj</span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="posts" matSort (matSortChange)="sortChanged($event)" >
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Nagłówek postu</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.deleted">
          <div class="statusChange-flex-container">
            <mat-chip-list>
              <mat-chip class="statusChange-button-container" matTooltip="Archiwum">A</mat-chip>
            </mat-chip-list>
            {{ element.name }}
          </div>
        </ng-container>
        <ng-container *ngIf="!element.deleted">
        <a class="default-link featured-image" [routerLink]="['szczegoly', element.uuid]">
          <img *ngIf="element.featuredImage?.src" [src]="environment.dobryAgentUrl + element.featuredImage?.src"  alt=""/>
          {{element.name}}
        </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="category">Kategoria</th>
      <td mat-cell *matCellDef="let element">
        {{element.blogCategory?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="tag">
      <th mat-header-cell *matHeaderCellDef> Tagi</th>
      <td mat-cell *matCellDef="let element">
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="author"> Autor</th>
      <td mat-cell *matCellDef="let element">
        <div class="statusChange-flex-container">
          <ng-container *ngIf="element.author && element.coordinator === null">
            <mat-chip class="statusChange-button-container"  color="primary" matTooltip="Autor">A</mat-chip>
        {{element.author?.firstName}} {{element.author?.lastName}}
          </ng-container>
          <ng-container *ngIf="element.coordinator">
            <mat-chip class="statusChange-button-container chip-yellow" selected matTooltip="Agent">O</mat-chip>
            {{element.coordinator?.firstName}} {{element.coordinator?.lastName}}
          </ng-container>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="publicationDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="publicationDate"> Data publikacji</th>
      <td mat-cell *matCellDef="let element">
        {{element.publicationDate | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Status</th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!element.active" mat-stroked-button [ngClass]="'disabled-button'">Nieaktywny</button>
        <button *ngIf="element.active" mat-raised-button  [ngClass]="'positive-button'">Aktywny</button>
      </td>
    </ng-container>
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="position"> Pozycja</th>
      <td mat-cell *matCellDef="let element">
        {{element.position}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="(userPermissions | async).dobry_agent.write">
          <div class="button-actions">
            <button *ngIf="element.deleted"
                    (click)="restore(element)" mat-stroked-button>
              <mat-icon>history</mat-icon>
              <span> Przywróć z archiwum</span>
            </button>
            <button *ngIf="!element.deleted"
                    (click)="deleteWeak(element.uuid)" mat-stroked-button>
              <mat-icon>archive</mat-icon>
              <span> Przenieś do archiwum</span>
            </button>
            <button
              (click)="delete(element)" mat-stroked-button color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-container>
       </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
